import App from './App.svelte';
import "mini.css/dist/mini-default.min.css"

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;
